<template>
    <button @click="changeButtonText" :class="{ active: isActive}">{{greeting}}</button>
</template>

<script>
export default {
    data() {
        return {
            greeting: 'I\'m a test Vue component!',
            isActive: false
        }
    },
    methods: {
        changeButtonText() {
            this.greeting = "You've clicked me!";
            this.isActive = true;
        }
    }
}
</script>

<style lang="scss" scoped>
button {
    background: #333;
    color: white;
    border: none;
    padding: 8px 16px;
    transition: 300ms;
    cursor: pointer;
    &:hover {
        background: lighten(#333, 10%);
    }
    &.active {
        background: red;
    }
}
</style>

